import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_a_select, {
      value: _ctx.computedValor,
      "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.computedValor) = $event)),
      onChange: _ctx.defineValorSelecionado,
      class: _normalizeClass('ss-tamanho-completo ' + _ctx.props.classCss),
      onBlur: _ctx.blur,
      disabled: _ctx.props.disabled,
      placeholder: _ctx.props.placeholder,
      "show-search": true
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_select_option, { value: 0 }, {
          default: _withCtx(() => [
            _createTextVNode("Todas")
          ]),
          _: 1
        }),
        _createVNode(_component_a_select_option, { value: 1 }, {
          default: _withCtx(() => [
            _createTextVNode("Apenas Emissão Normal")
          ]),
          _: 1
        }),
        _createVNode(_component_a_select_option, { value: 2 }, {
          default: _withCtx(() => [
            _createTextVNode("Apenas Devolvidas")
          ]),
          _: 1
        }),
        _createVNode(_component_a_select_option, { value: 3 }, {
          default: _withCtx(() => [
            _createTextVNode("Apenas Canceladas")
          ]),
          _: 1
        }),
        _createVNode(_component_a_select_option, { value: 4 }, {
          default: _withCtx(() => [
            _createTextVNode("Apenas Complementares")
          ]),
          _: 1
        }),
        _createVNode(_component_a_select_option, { value: 5 }, {
          default: _withCtx(() => [
            _createTextVNode("Apenas de Ajuste")
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["value", "onChange", "class", "onBlur", "disabled", "placeholder"])
  ]))
}